/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq_Q2Inputs */

const en_pricing_faq_q2 = /** @type {(inputs: Pricing_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What counts as an AI action?`)
};

const de_pricing_faq_q2 = /** @type {(inputs: Pricing_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was zaehlt als KI-Aktion?`)
};

const fr_pricing_faq_q2 = /** @type {(inputs: Pricing_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is there a free plan?`)
};

const es_pricing_faq_q2 = /** @type {(inputs: Pricing_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is there a free plan?`)
};

const it_pricing_faq_q2 = /** @type {(inputs: Pricing_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is there a free plan?`)
};

const nl_pricing_faq_q2 = /** @type {(inputs: Pricing_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is there a free plan?`)
};

const pl_pricing_faq_q2 = /** @type {(inputs: Pricing_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is there a free plan?`)
};

const fi_pricing_faq_q2 = /** @type {(inputs: Pricing_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is there a free plan?`)
};

const da_pricing_faq_q2 = /** @type {(inputs: Pricing_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is there a free plan?`)
};

const sv_pricing_faq_q2 = /** @type {(inputs: Pricing_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is there a free plan?`)
};

/**
* | output |
* | --- |
* | "What counts as an AI action?" |
*
* @param {Pricing_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_faq_q2 = /** @type {((inputs?: Pricing_Faq_Q2Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq_Q2Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_faq_q2(inputs)
	if (locale === "fr") return fr_pricing_faq_q2(inputs)
	if (locale === "es") return es_pricing_faq_q2(inputs)
	if (locale === "it") return it_pricing_faq_q2(inputs)
	if (locale === "nl") return nl_pricing_faq_q2(inputs)
	if (locale === "pl") return pl_pricing_faq_q2(inputs)
	if (locale === "fi") return fi_pricing_faq_q2(inputs)
	if (locale === "da") return da_pricing_faq_q2(inputs)
	if (locale === "sv") return sv_pricing_faq_q2(inputs)
	return en_pricing_faq_q2(inputs)
});